module.exports = __webpack_public_path__ + "static/media/R12.e07d7106.jpg";